import axios from "axios";
export default class TicketController {
    static BASE_URL = `https://yck9csg4hi.execute-api.eu-central-1.amazonaws.com/Prod`
    static async getInfoMatricola(matricola:string){
        return await axios.get(`https://zenbridge.effegibi.it/server.php?function=request&matricola=${matricola}`)
    }
    static async newTicket(payload:any){    
        for (const role of ["customer", "contact"]) {
            const person = payload?.[role]
            if (person && (person.email) && (person.address || person.cap || person.province || person.country)) {
                person.address = `${person.address || ''} ${person.cap || ''} ${person.province || ''} - ${person.country || ''} `
                person.codice_postale = person.cap || ''
                person.leadin_provincie__regio_a81e3376de5400f182f4c31130b1b950 = person.province || ''
                delete person.cap
                delete person.province
            }
        }
        return axios.post(`${TicketController.BASE_URL}/ticket`,payload)
    }
}
